import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-m01-account-anchor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_component_IconBase, {
      class: "p-m01-account-anchor__icon",
      "view-box": "0 0 24 24",
      width: "24",
      height: "24"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IconArrowRight)
      ]),
      _: 1
    })
  ]))
}